import { delay } from "../utils/async";
import { Dispatcher } from "../utils/events/dispatcher";
import { DataCacheObject } from "./data_cache_object";
import { DataProvider, DataProviderQueryResult, NON_EXISTING } from "./data_provider";

export class ServerDataProvider implements DataProvider {
  private cache = new Map<string, DataProviderQueryResult>();

  constructor(private spec: DataSpec) {}

  get(ids: string[]): DataProviderQueryResult {
    const cacheKey = ids.join(".");
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey)!;
    }

    const dispatcher = new Dispatcher();
    const onUpdate = dispatcher.cachingSignal();
    this.getValue(ids).then((value) => {
      dispatcher.emit(onUpdate, value);
    });

    const result = {
      onUpdate,
    };

    this.cache.set(cacheKey, result);

    return result;
  }

  private async getValue(ids: string[]): Promise<unknown | typeof NON_EXISTING> {
    let spec = this.spec;
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      if (id !== undefined) {
        if (spec[id]) {
          spec = spec[id];
          continue;
        }

        const getByIdFn = spec[GET_BY_ID];
        if (getByIdFn) {
          return await getByIdFn(ids.slice(i));
        }

        return NON_EXISTING;
      }
    }
  }

  getCache(): DataCacheObject {
    const obj: DataCacheObject = {};
    for (const [key, value] of this.cache) {
      if (value.onUpdate.hasValue) {
        obj[key] = value.onUpdate.lastValue;
      }
    }

    return obj;
  }
}

export const GET_BY_ID = Symbol("GET_BY_ID");

export interface DataSpec {
  [key: string]: DataSpec;
  [GET_BY_ID]?: (ids: string[]) => Promise<unknown>;
}
